import React from 'react';
import './Styles/Sidebar.css'

const StepItem = ({ step, isActive, onClick }) => {
  return (
    <div className="step-item" onClick={() => onClick(step.id)}>
      <div className={`step-number ${isActive ? 'active' : ''}`}>
        {step.id}
      </div>
      <div className="step-content">
        <h3 className={`step-title ${isActive ? 'active' : ''}`}>
          {step.title}
        </h3>
        <p className="step-description">{step.description}</p>
      </div>
    </div>
  );
};

export default StepItem;